import { render, staticRenderFns } from "./wy-configurations.vue?vue&type=template&id=feb0f348&"
import script from "./wy-configurations.vue?vue&type=script&lang=js&"
export * from "./wy-configurations.vue?vue&type=script&lang=js&"
import style0 from "./wy-configurations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports